<template>
  <div class="content-center">
    <TheBbStartDateSelect
      :on-selected-date="setStartDateOfUse"
      :is-date-limited-in="isValidDate"
      :start-date-of-use="startDateOfUse"
      :master-book="masterBook"
    >
      <template #beforeCaution>
        <p class="error-block">
          ※引き換え後の利用開始日変更はできませんので<br />ご注意ください
        </p>
      </template>
    </TheBbStartDateSelect>

    <br />
    <br />

    <div v-if="isDisplayCouponTerm" class="terms-section">
      <TheMbImportantLinkCollection :url="couponTermsUrl" />
      <label class="terms-agree">
        <SurveyCheckbox
          :checked="isAgreedTerms"
          :on-change="toggleAgreedTerms"
        />
        <span class="terms-agree-text">{{ $t("common.agreeToTerms") }}</span>
      </label>
    </div>

    <ItemButton
      label="クーポンを引き換える"
      action-type="btn-primary"
      :disabled="!isSubmitEnabled"
      @clicked="clickedIssue()"
    />
  </div>

  <DialogRedemptionConfirmation
    ref="DialogRedemptionConfirmation"
    @clicked="createBookGroupWithVoucher"
  />

  <DialogQRFail
    ref="QRFail"
    :fail-title="failTitle"
    @clicked="backToVoucherInput"
  />
</template>

<script>
import dateService from "@/services/bookBookingDate";
import nativeHandlerService from "@/services/nativeHandler";
import { buildShareholderSurveyRoute } from "@/services/survey";
import { useTermsAgreement } from "@/composables/useTermsAgreement";

import { mapGetters } from "vuex";

import API from "@/API";

export default {
  name: "DialogSelectDate",
  props: {
    requestCode: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { isAgreed: isAgreedTerms, toggleAgreed: toggleAgreedTerms } =
      useTermsAgreement();
    return { isAgreedTerms, toggleAgreedTerms };
  },
  data() {
    return {
      startDateOfUse: "",
      failTitle: "読み込みがうまくいきませんでした",
    };
  },
  methods: {
    async setStartDateOfUse(selectedDate) {
      this.startDateOfUse = selectedDate;
    },
    async clickedIssue() {
      this.$refs.DialogRedemptionConfirmation.openDialog();
    },

    async createBookGroupWithVoucher() {
      console.log(
        "createBookGroupWithVoucher this.requestCode :>> ",
        this.requestCode
      );
      try {
        // POST API
        await API.createBookGroupWithVoucher({
          code: this.requestCode,
          started_at: this.$moment(new Date(this.startDateOfUse)).format(),
        });

        // 計測用ネイティブコール
        await nativeHandlerService.ncCouponComplete(this.requestCode);

        if (this.bookGroup.master_survey_id > 0) {
          this.$router.push(buildShareholderSurveyRoute(this.bookGroup, this.masterBook));
          return;
        }

        this.$router.push({
          name: "BookBookingResult",
          params: {
            id: this.masterBook.id,
            book_group_id: this.bookGroup.id,
          },
          query: {
            voucher: true,
            language: this.$store.getters["common/lang"],
          },
        });
      } catch (err) {
        console.log("err :>> ", err);
        // エラーの場合は400 bad_request 既に引換済み
        this.failTitle = "引き換え済みのコードです";
        this.$refs.QRFail.openDialog();
      }
    },

    backToVoucherInput() {
      this.$emit("parentMethod");
    },
  },
  computed: {
    isValidDate() {
      return dateService.checkIsValidDate(
        this.masterBook.purchase_started_at,
        this.masterBook.purchase_limited_at,
        this.startDateOfUse
      );
    },
    isDisplayCouponTerm() {
      return Boolean(
        this.masterBook.content?.description_json?.IsDisplayCouponTerm
      );
    },
    couponTermsUrl() {
      return this.masterBook.content?.terms_url;
    },
    isSubmitEnabled() {
      return (
        this.isValidDate &&
        (!this.isDisplayCouponTerm || this.isAgreedTerms)
      );
    },
    ...mapGetters("ticketing", ["bookGroup", "masterBook"]),
  },
};
</script>
<style lang="scss" scoped>
.content-center {
  position: relative;
  width: 95%;
  margin: 0 auto;
  top: var(--navigation-height);
  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
}

.error-block {
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: left;
  line-height: 17px;
  color: #ff3333;
}

.terms-section {
  margin-bottom: 20px;
}

.terms-agree {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 15px;
  cursor: pointer;
}

.terms-agree-text {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
</style>
